import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

const lightTheme = {
  dark: false,
  colors: {
    // Standard Vuetify slots
    primary: '#0b201f',           // negro
    'on-primary': '#ffffff',
    secondary: '#757575',         // texto atenuado
    'on-secondary': '#ffffff',
    surface: '#ffffff',           // blanco
    'on-surface': '#0b201f',      // texto
    background: '#f5f5f5',        // fondo
    'on-background': '#0b201f',
    success: '#009951',           // verde oscuro
    error: '#c00f0c',             // rojo oscuro
    info: '#007aff',              // azul oscuro
    warning: '#ffcc00',           // amarillo

    // Custom slots (project-specific tokens)
    green: '#00d97c',
    negro: '#0b201f',
    negro2: '#132827',
    fx: '#01ff94',                // verde neon
    fxSubtle: '#00d97c',
    successContainer: '#cff7d3',  // verde claro
    errorContainer: '#fcb3ad',    // rojo claro
    errorContainer2: '#fdd3d0',
    infoContainer: '#d9ebff',     // azul claro
    border: '#e3e3e3',            // borde
    borderLight: '#f3f4f6',       // borde interior (filas de detalle)
    timelineLine: '#dcfce7',      // linea del flujo de aprobacion
    mutedText: '#757575',
    placeholderText: '#b3b3b3',
    oscuro500: '#435554',
    amarillo500: '#f4c430',       // badge "Programado" (Figma: Amarillo/500)
    amarillo100: '#fef3cf',       // fondo del chip amarillo (Figma: Amarillo/100)
  },
  variables: {
    'border-color': '#e3e3e3',
    'border-opacity': 1,
  },
}

export default createVuetify({
  // El diseño no usa el ripple de Material: se desactiva globalmente en vez de repetir
  // `:ripple="false"` en cada boton.
  defaults: {
    VBtn: { ripple: false },
  },
  theme: {
    defaultTheme: 'light',
    themes: { light: lightTheme }
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
})
